<template>
  <div v-if="creditStatementDataProps">
    <div class="pt-6 rounded p-4 card ">
      <section class="justify-center text-center">
          <p class="font-semibold text-xs text-white font-sans">CURRENT BALANCE</p>
          <p class="font-normal text-xl text-white font-sans">{{$filters.formatMoney(creditStatementDataProps?.pendingTransactions?.availableCreditLimit)}}</p>
      </section>
      <section class="px-4 py-2">
          <hr/>
      </section>
      <section class="flex justify-between px-4 py-2">
          <div>
              <p class="font-normal text-xs text-white font-sans">AMOUNT PAYABLE</p>
              <p class="font-normal text-xl text-white font-sans">{{$filters.formatMoney(creditStatementDataProps?.pendingTransactions?.outstandingAmount)}}</p>
          </div>
          <div>
              <p class="font-normal text-xs text-white font-sans">NEXT DUE DATE</p>
              <p v-if="creditStatementDataProps?.pendingTransactions?.unsettledTransactionList" class="font-semibold text-xl text-white font-sans">{{formatDate(creditStatementDataProps?.pendingTransactions?.unsettledTransactionList[0].txnDueDate)}}</p>
              <p v-else class="font-semibold text-base text-white font-sans">No Due Date</p>
          </div>
      </section>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CreditStatementCard',
  components: {
  },
  computed: {
    ...mapGetters(['creditAccountInfo']),
  },
  data() {
    return {
      isLoading: false
    };
  },
  mounted() {
    this.init();
  },
  watch: {
  },
  props: {
    creditStatementDataProps: {
        type: Object,
    },
  },
  methods: {
    init() {
    },
    formatDate(userDOB) {
      const dob = new Date(userDOB);
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June', 'July',
        'August', 'September', 'October', 'November', 'December'
      ];

      const day = dob.getDate();
      const monthIndex = dob.getMonth();
      const year = dob.getFullYear();
      return `${day} ${monthNames[monthIndex]} ${year}`;
    },
  },
};
</script>
<style scoped>
.card{
  background: linear-gradient(180deg, #00759D 49.26%, #005172 100%);
}
</style>
